<template>
    <v-main class="mt-n16">
        <v-main class="mt-n10 px-sm-3 mb-n7" fluid>
            <v-row>
                <v-col cols="12" sm="4" lg="4">
                    <NotifyToWidget></NotifyToWidget>
                </v-col>

                <v-col cols="12" sm="8" lg="8" v-if="groupSetting.groupName == '방산포장' && userRole == 'superuser'">
                    <CommonDataWidget></CommonDataWidget>
                </v-col>
            </v-row>

            <v-container class="mt-10 mb-10"></v-container>
        </v-main>
    </v-main>
</template>

<script>
import NotifyToWidget from "@/components/admin/widget/NotifyToWidget";
import CommonDataWidget from "@/components/admin/widget/CommonDataWidget"

export default {
    name: 'Settings',
    components: {
        NotifyToWidget,
        CommonDataWidget
    },
    data: () => ({
        groupSetting : null,
        userRole: null
    }),
    created: function() {
        if(this.$store.getters.getGroupSetting != null){
            this.groupSetting = this.$store.getters.getGroupSetting
            this.userRole = this.$store.getters.getUserRole
        }
    },
    beforeCreate: function() {

        if(!this.$store.getters.getAccessToken){
            this.$router.push('/user/login')
        }

    }
}
</script>